import { MAX_LIMIT } from "../files-controller";

export const getAttachedFilesCount = (length: number) => {
  if (!length) {
    return "";
  }

  if (length >= MAX_LIMIT) {
    return "max";
  }

  return `${length}`;
};
